"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_1 = require("react");
const approvalHelpers_1 = require("./approvalHelpers");
const approvalInfos_1 = __importDefault(require("./approvalItem/approvalInfos"));
const approvalItem_1 = __importDefault(require("./approvalItem/approvalItem"));
const actionButtonsWrapper_1 = __importDefault(require("./approvalItem/buttons/actionButtonsWrapper"));
const useApprovalsData_1 = require("./hooks/useApprovalsData");
const CreateCardAside = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('../../organisms/createCard'))));
const ForwardRequestAside = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./asides/forwardRequestAside'))));
const OutOfOfficeAside = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./asides/outOfOfficeAside'))));
const ApprovalList = () => {
    const theme = (0, material_1.useTheme)();
    const { sortedAndFilteredApprovals, currentActiveApprovalTab } = (0, useApprovalsData_1.useApprovalsData)();
    return ((0, jsx_runtime_1.jsxs)(material_1.Grid, { "data-testid": "approval-list", container: true, direction: "row", style: {
            padding: `${theme.tsGoUnit.tsUnitHalf} ${theme.tsGoUnit.tsUnit}`,
            gap: theme.tsGoUnit.tsUnit,
            overflow: 'auto',
        }, children: [sortedAndFilteredApprovals.length === 0 ? ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, direction: "column", sx: {
                    justifyContent: 'center',
                    alignItems: 'center',
                }, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h5", "ts-variant": "no-list-info", children: (0, approvalHelpers_1.getEmptyMessage)(currentActiveApprovalTab) }) })) : (sortedAndFilteredApprovals.map(approvalItem => ((0, jsx_runtime_1.jsx)(material_1.Grid, { "data-testid": "approval-item", style: { flex: '1 1 100%' }, children: (0, jsx_runtime_1.jsxs)(approvalItem_1.default, { approvalItem: approvalItem, children: [(0, jsx_runtime_1.jsx)(actionButtonsWrapper_1.default, { shouldShowViewConversationButton: true, approvalItem: approvalItem }), (0, jsx_runtime_1.jsx)(approvalInfos_1.default, { approvalItem: approvalItem })] }) }, approvalItem.id)))), (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)("div", {}), children: (0, jsx_runtime_1.jsx)(ForwardRequestAside, {}) }), (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)("div", {}), children: (0, jsx_runtime_1.jsx)(OutOfOfficeAside, {}) }), (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)("div", {}), children: (0, jsx_runtime_1.jsx)(CreateCardAside, {}) })] }));
};
exports.default = ApprovalList;
